import { StatePanel } from '../common/feedback/StatePanel'
import styles from './RecordWorkspace.module.css'

const WHITESPACE_PATTERN = /\s+/

function initialsFor(value) {
  return String(value || '')
    .trim()
    .split(WHITESPACE_PATTERN)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('') || '—'
}

export function RecordIdentity({
  title,
  subtitle,
  visual,
  initials,
  badges,
  titleAttribute,
  className = '',
}) {
  const fallbackInitials = initials || initialsFor(typeof title === 'string' ? title : subtitle)
  return (
    <span className={`${styles.identity} ${className}`.trim()}>
      <span className={styles.identityVisual} aria-hidden="true">{visual || fallbackInitials}</span>
      <span className={styles.identityCopy}>
        <strong title={titleAttribute || (typeof title === 'string' ? title : undefined)}>{title}</strong>
        {subtitle ? <span>{subtitle}</span> : null}
      </span>
      {badges ? <span className={styles.identityBadges}>{badges}</span> : null}
    </span>
  )
}

export function RecordWorkspace({
  label = 'Records',
  toolbar,
  summary,
  selectionActions,
  footer,
  loading = false,
  error,
  restricted = false,
  disabled = false,
  items = [],
  filtered = false,
  emptyTitle = 'No records yet',
  emptyDescription,
  searchEmptyTitle = 'No records match your filters',
  onRetry,
  onClear,
  primaryAction,
  children,
  className = '',
}) {
  let state = null
  if (!loading && error) state = <StatePanel state="error" title="Records could not load" description={error.message || String(error)} onRetry={onRetry} />
  else if (!loading && restricted) state = <StatePanel state="restricted" title="Access restricted" description="Your current role cannot view these records." />
  else if (!loading && disabled) state = <StatePanel state="disabled" title="Not available" description="Configure this capability to continue." />
  else if (!loading && !items.length && filtered) state = <StatePanel state="search-empty" title={searchEmptyTitle} onClear={onClear} />
  else if (!loading && !items.length) state = <StatePanel state="empty" title={emptyTitle} description={emptyDescription} action={primaryAction} />

  return (
    <section className={`${styles.workspace} ${className}`.trim()} aria-label={label} aria-busy={loading || undefined}>
      {toolbar ? <div className={styles.toolbar}>{toolbar}</div> : null}
      {summary ? <div className={styles.summary}>{summary}</div> : null}
      {selectionActions ? <div className={styles.selection}>{selectionActions}</div> : null}
      {state || <div className={styles.results}>{children}</div>}
      {!state && !loading && footer ? <div className={styles.footer}>{footer}</div> : null}
    </section>
  )
}

export default RecordWorkspace
